/* UnionX — carga de las imagenes de los menus.
   13/08/2026: nacio para que el celular no bajara las 23 imagenes del mega-menu (629 KB),
   que ahi no se ven nunca. Se resolvio con un media query: solo escritorio.

   🔴 23/08/2026 — ese media query estaba al reves para la OTRA mitad del menu, y medido
   en el Horizon nuevo daba las dos cosas mal a la vez:
     · en escritorio bajaba 65 imagenes del CAJON lateral, que ahi mide 0x0 y no se ve;
     · en celular de 390px, al abrir el cajon salian 67 casillas de 143px TODAS EN BLANCO,
       porque `cargar()` cortaba antes de ponerles el src.
   El supuesto de la version vieja —"en celular el cajon no muestra imagenes"— era cierto
   en el tema de Lhotse, no en este.

   Ahora cada mitad carga donde de verdad se ve:
     · mega-menu  -> solo escritorio, de inmediato (si esperara al hover, parpadea).
     · cajon      -> cuando su caja deja de medir 0, o sea cuando el cajon se abre.
                     En escritorio no se abre nunca, asi que no baja nada.

   🪤 Horizon vuelve a renderizar el mega-menu por la Section Rendering API DESPUES de
   DOMContentLoaded. Sin el MutationObserver quedaban 23 de 46 sin src.
   Respaldo del original de Horizon: assets/lh-respaldo-link-featured-image-20260813.liquid */
(function () {
  var CONSULTA = '(min-width: 750px)';
  function esEscritorio() { return !window.matchMedia || window.matchMedia(CONSULTA).matches; }
  function esDelCajon(el) {
    return el.className.indexOf('menu-drawer__link-image') >= 0 ||
           (el.closest && !!el.closest('.menu-drawer, menu-drawer, [class*="menu-drawer"]'));
  }
  /* 24/08/2026: el srcset ya NO viene en el HTML. Venia como atributo Y otra vez dentro de un
     <noscript>, y con 119 imagenes de menu eso eran 132 KB en CADA pagina del sitio. Ahora el
     HTML trae un solo URL (el de 450w) y el srcset se arma aca cambiando el parametro width. */
  var ANCHOS = [300, 450, 600, 800];
  function armarSrcset(url) {
    if (!/[?&]width=\d+/.test(url)) return null;
    var partes = [];
    for (var i = 0; i < ANCHOS.length; i++) {
      partes.push(url.replace(/([?&]width=)\d+/, '$1' + ANCHOS[i]) + ' ' + ANCHOS[i] + 'w');
    }
    return partes.join(', ');
  }
  function encender(el) {
    if (!el.hasAttribute('data-lhx-menuimg')) return;
    var url = el.getAttribute('data-lhx-menuimg');
    /* el srcset PRIMERO: al reves el navegador ya arranco con el fallback y baja dos veces */
    var ss = armarSrcset(url);
    if (ss) el.srcset = ss;
    el.src = url;
    el.removeAttribute('data-lhx-menuimg');
  }
  var mirador = window.IntersectionObserver
    ? new IntersectionObserver(function (entradas, obs) {
        for (var i = 0; i < entradas.length; i++) {
          if (entradas[i].isIntersecting) { encender(entradas[i].target); obs.unobserve(entradas[i].target); }
        }
      }, { rootMargin: '300px' })
    : null;
  function cargar(raiz) {
    var pendientes = (raiz || document).querySelectorAll('img[data-lhx-menuimg]');
    for (var i = 0; i < pendientes.length; i++) {
      var el = pendientes[i];
      if (esDelCajon(el)) {
        if (mirador) mirador.observe(el);
        else if (!esEscritorio()) encender(el);   /* sin IO: al menos que el celular las vea */
      } else if (esEscritorio()) {
        encender(el);
      }
    }
  }
  function arrancar() {
    cargar();
    if (window.MutationObserver) {
      new MutationObserver(function (cambios) {
        for (var i = 0; i < cambios.length; i++) {
          if (cambios[i].addedNodes && cambios[i].addedNodes.length) { cargar(); return; }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  window.addEventListener('resize', function () { cargar(); }, { passive: true });
})();
